import { createAsyncThunk } from '@reduxjs/toolkit'
import { getUserCoursesData } from './api'

export const getUserCourses = createAsyncThunk('geUserCourses', async payload => {
  const res = await getUserCoursesData(payload)

  return res?.myCourse
})
